import _ from "lodash";
import SSO from "../../sso";
import fetchWithJWT from "../../services/auth/fetchWithJWT";
import _config from "../../config";

export const docStatuses = [
  "In Progress",
  "Auditor Ready",
  "Reviewed for closing",
  "Partially Executed",
  "Fully Executed",
  "Recorded",
  "Public Viewable",
];

export function getDocumentType(value, documentTypes) {
  if (!value) {
    return "";
  }

  const index = _.findIndex(documentTypes, { type_name: value });
  return index >= 0 ? documentTypes[index].label_text : value;
}

export function getDateToDisplay(value) {
  if (!value) {
    return "";
  }
  
  const res = value.split("T");
  return res[0];
}

export function getDocumentStatus(value) {
  if (!value) {
    return "";
  }

  const docStatus = value.filter(r => docStatuses.includes(r));
  return docStatus.length > 0 ? docStatus[0] : "";
}

export const downloadDocument = (
  documentId,
  isLatestVersion,
  openErrorModel,
  setLoading,
) => {
  const downloadDocUrl = `${_config.BASE_URL}document?docID=${documentId}&isLatestVersion=${isLatestVersion}`;
  setLoading(true, documentId);
  
  fetchWithJWT(downloadDocUrl)
    .then(async (response) => {
      if (response.status === 200) {
        return { success: true, blob: await response.blob() };
      }
      
      if (response.status === 401) {
        setLoading(false, null);
        SSO.redirectToSignInUrl(response.signInUrl);
        return { success: false };
      }
      
      // Handle error responses (415, 404, 500, etc.)
      let errorMessage = "An error occurred while attempting to locate this document.";
      let errorTitle = "Document Error";
      
      try {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.toLowerCase().includes("application/json")) {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
          
          // Specific handling for common error codes
          if (response.status === 415) {
            errorTitle = "Unsupported Document Type";
            errorMessage = errorData.message || "The document format is not supported. Expected PDF format.";
          } else if (response.status === 404) {
            errorTitle = "Document Not Found";
            errorMessage = "The requested document could not be found. It may have been deleted or moved.";
          } else if (response.status >= 500) {
            errorTitle = "Server Error";
            errorMessage = "A server error occurred while retrieving the document. Please try again later.";
          }
        } else {
          errorMessage = `Unable to open document (Status: ${response.status})`;
        }
      } catch (parseError) {
        console.error("Failed to parse error response:", parseError);
        errorMessage = `Unable to open document (Status: ${response.status})`;
      }
      
      setLoading(false, null);
      openErrorModel(errorTitle, errorMessage);
      
      return { success: false };
    })
    .then(result => {
      if (result && result.success && result.blob) {
        const fileURL = URL.createObjectURL(result.blob);
        const newWindow = window.open(fileURL);

        if (!newWindow) {
          setLoading(false, null);
          URL.revokeObjectURL(fileURL);
          openErrorModel('Popup Blocked', 'Please allow popups for this site to view documents.');
          return;
        }

        if (typeof newWindow.addEventListener === 'function') {
          newWindow.addEventListener('beforeunload', () => {
            URL.revokeObjectURL(fileURL);
          }, { once: true });
        }

        setLoading(false, null);
      }
    })
    .catch(err => {
      console.error("Document download error:", err);
      setLoading(false, null);
      openErrorModel("Download Failed", "An unexpected error occurred while downloading the document.");
    });
};

export function setDocumentStatus(versionLabel, docStatus) {
  if (!docStatus) {
    return versionLabel;
  }

  const versionLabelReturn = [];
  const numericVersion = versionLabel.find(r => !isNaN(r));
  
  if (numericVersion !== undefined) {
    versionLabelReturn.push(numericVersion);
  }
  
  if (versionLabel.includes("CURRENT")) {
    versionLabelReturn.push("CURRENT");
  }
  
  versionLabelReturn.push(docStatus);
  return versionLabelReturn;
}

export function setDate(date) {
  return (date && date !== "null") ? date : "";
}
